module.exports = __webpack_public_path__ + "./Anita_pbw_be0f74fe99373fd5a2fa3bc8d4a4a462.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Anita_pbw.png
// module id = 585
// module chunks = 0